module.exports = __webpack_public_path__ + "static/media/Montserrat-Medium.0098f804.ttf";